import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubBrowseAllArticlesRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-browse-all-articles',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
	exact: true,
};
